module.exports = __webpack_public_path__ + "img/allx.c535d39b.svg";